export default { sha: '79dd6482de5cf1d1bc6152b4c21093d82ea7e0e9', buildNumber: 'undefined' }
